/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsIdleAwsAdvisor extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsIdleAwsAdvisor");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsIdleAwsAdvisor.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsIdleAwsAdvisor>): AdditionalResourceDetailsForFinopsIdleAwsAdvisor {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsIdleAwsAdvisor(), model);
        AdditionalResourceDetailsForFinopsIdleAwsAdvisor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsIdleAwsAdvisor>): AdditionalResourceDetailsForFinopsIdleAwsAdvisor {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsIdleAwsAdvisor.newInstance(<AdditionalResourceDetailsForFinopsIdleAwsAdvisor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsIdleAwsAdvisor) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsIdleAwsAdvisor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsIdleAwsAdvisor): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsIdleAwsAdvisor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * LookBack Period in days
     */
    lookback_period: string;

    /**
     * Reason
     */
    reason: string;

    /**
     * Snapshot ID
     */
    snapshot_id: string;

}
